import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import "@authoxi/ui-shared/styles/tokens.css";
import "@authoxi/ui-shared/styles/base.css";
// The shared lead gate's structure. No colour of its own — every value is a var() on the
// tokens imported above, so it inherits this product's palette by being loaded after them.
import "@authoxi/ui-shared/leadgate.css";
import "./styles.css";
import App from "./App";

// Landing commits to the void ground and has no theme toggle. That is a choice: the four
// verdict colours are the whole visual argument and they only blaze on near-black. A light
// landing page would be a different, quieter product.
document.documentElement.classList.add("on-void");

hydrateRoot(
  document.getElementById("root")!,
  <StrictMode>
    <App />
  </StrictMode>,
);
